import type { ThreadRow } from "../contract"

export type HistoryGroup = "Today" | "This week" | "Earlier"
export const GROUPS: HistoryGroup[] = ["Today", "This week", "Earlier"]

/** Thread rows may carry timestamps (the store's summaries do); without one a row is "Earlier". */
type DatedRow = ThreadRow & { updated_at?: string | null; created_at?: string | null }

const DAY = 864e5

/** Group threads by last activity: Today, This week (last 7 days), Earlier. Order is kept. */
export function groupThreads(rows: ThreadRow[], now: Date = new Date()): Record<HistoryGroup, ThreadRow[]> {
  const out: Record<HistoryGroup, ThreadRow[]> = { Today: [], "This week": [], Earlier: [] }
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
  for (const r of rows as DatedRow[]) {
    const ts = Date.parse(r.updated_at || r.created_at || "")
    if (Number.isNaN(ts)) out.Earlier.push(r)
    else if (ts >= start) out.Today.push(r)
    else if (ts >= start - 6 * DAY) out["This week"].push(r)
    else out.Earlier.push(r)
  }
  return out
}
